(function (appComponents) {

	appComponents.prototypes.controller = function (Components) {

		var protoController = {
			__proto__: Components.getComponentPrototype(),
			get _isActiveController() {
				return (this._page.title == this.name) ? true : false;
			},
		};

		var stateObject = {
			parent: null,
			hasState: false,
			dom: null,
			context: null,
			loadState: function () {
				this.parent.context = this.context;
			},
			saveState: function () {
				this.hasState = true;
				this.context = this.parent.context;
			}
		};

		// add additional argument to apply any plugin after rendering
		protoController._renderPageTemplate = function (ignoreAnimation) {
			if (!this._isActiveController) return;
			var html = this.templates.main(this.context);
			this._elements.body.removeClass().addClass(this._page.bodyStyle);
			if (ignoreAnimation) {
				this._elements.page.html(html);
			} else {
				this._elements.page.hide().html(html).fadeIn("fast");
			}
		};

		protoController._createState = function () {
			var state = Object.create(stateObject);

			state.parent = this;

			this._state = state;
		};

		return protoController;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});